<app-breadcrumb [breadcrumbs]="breadcrumbs"></app-breadcrumb>

<h1 class="page-title">Home</h1>

<mat-divider class="page-title-divider"></mat-divider>

<div class="loader">
    <ngx-skeleton-loader count="5" appearance="line" [theme]="{height: '64px'}" />
</div>
